export const isDevEnv = () => import.meta.env.VITE_ENVIRONMENT === 'dev'
export const isProdEnv = () => import.meta.env.VITE_ENVIRONMENT === 'prod'
export const isStageEnv = () => import.meta.env.VITE_ENVIRONMENT === 'stage'
export const isAddNonTerminalDeviceEnabled = () => isDevEnv()
export const isTemperTestEnabled = () => isDevEnv()
